import { useState, type ComponentType, type MouseEvent as ReactMouseEvent } from 'react';
import { Colors } from '../../themes/colors';

interface IMenuItemProps {
  text: string;
  Icon?: ComponentType;
  onClick: (event: ReactMouseEvent<HTMLButtonElement>) => void;
  listener?: () => void;
  dataCy?: string;
}

export function MenuItem({ text, Icon, onClick, listener, dataCy }: IMenuItemProps) {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleOnClick = (event: ReactMouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    listener?.();
    onClick(event);
  };

  return (
    <button
      type="button"
      data-cy={dataCy}
      style={{
        all: 'unset',
        cursor: 'pointer',
        backgroundColor: isHovered ? Colors.neutral_100 : 'transparent',
        height: 36,
        borderRadius: 6,
        padding: '0 8px',
        margin: '0 4px',
      }}
      onClick={handleOnClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        {Icon && (
          <div
            style={{
              width: 32,
            }}
          >
            <Icon />
          </div>
        )}
        {/* To keep the same content width when text is bold */}
        <span
          style={{
            position: 'relative',
            display: 'inline-block',
            fontFamily: 'Nunito',
            fontSize: 16,
            color: Colors.neutral_600,
            fontWeight: isHovered ? 700 : 400,
          }}
        >
          <span
            style={{
              visibility: 'hidden',
              fontWeight: 700,
            }}
          >
            {text}
          </span>
          <span
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
            }}
          >
            {text}
          </span>
        </span>
      </div>
    </button>
  );
}